import React from 'react'
import Helmet from 'react-helmet'

const WebComponentChatbot = (props) => {
  return (
    <>
      <Helmet>
        <script type="module" src="/static/chatbot-web-component.js" />
      </Helmet>
      <dfb-chatbot name={props.name} endpoint={props.endpoint} historySize={props.historySize}></dfb-chatbot>
    </>
  )
}

export default WebComponentChatbot
